import React from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material"
import { SlotToPick } from "../../../types"
import { phoneNumber } from "../../../config"

interface SelfBookingSharedLessonDialogProps {
  slot?: SlotToPick
  onDismissCallback: () => void
  onConfirmCallback: () => void
}

export function SelfBookingSharedLessonDialog({
  slot,
  onConfirmCallback,
  onDismissCallback,
}: SelfBookingSharedLessonDialogProps) {
  return (
    <Dialog
      open={!!slot}
      onClose={onDismissCallback}
      data-cy="self-booking-shared-lesson-dialog"
    >
      <DialogTitle>Booking Shared Lesson</DialogTitle>
      <DialogContent>
        {slot?.isUnpaired ? (
          <>You will be sharing this lesson with another student.</>
        ) : (
          <>
            This lesson will be opened for other student(s) to be paired with
            you. At this time, it is not paired.
          </>
        )}{" "}
        You will have one hour of driving time and one hour of observation time.
        If you need a personalized shared lesson, please text or call us at{" "}
        {phoneNumber}.
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onConfirmCallback}>
          Confirm
        </Button>
        <Button onClick={onDismissCallback}>Cancel</Button>
      </DialogActions>
    </Dialog>
  )
}
